import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import lang from "../../../assets/lang/icons.json";

const FeaturesTemplate = ({
  isBanner,
  isDisclaimer,
  isDownloadApps,
  isHtml,
  isQuote,
  isVideo,
  isVideoConference,
}) => {
  const userData = useSelector((state) => state.user);
  const userStyle = useSelector((state) => state.userStyle);
  const uploadBanner = useSelector((state) => state.uploadBanner);
  const disclaimer = useSelector((state) => state.disclaimer);
  const downloadApp = useSelector((state) => state.downloadApp);
  const htmlFeature = useSelector((state) => state.htmlFeature);
  const quote = useSelector((state) => state.quote);
  const videoConference = useSelector((state) => state.videoConference);
  const userFeatures = useSelector((state) => state.userFeatures);

  const [currentFeature, setCurrentFeature] = useState(
    userFeatures.currentFeature[0].currentFeature
  );

  const [bannerImageUrl, setBannerImageUrl] = useState("");
  const [bannerUrl, setBannerUrl] = useState("");

  const [disclaimerFeatureText, setDisclaimerFeatureText] = useState("");
  const [disclaimerFeatureColor, setDisclaimerFeatureColor] = useState("");
  const [disclaimerFeatureSize, setDisclaimerFeatureSize] = useState("");

  const [quoteFeatureText, setQuoteFeatureText] = useState("");
  const [quoteFeatureColor, setQuoteFeatureColor] = useState("");
  const [quoteFeatureSize, setQuoteFeatureSize] = useState("");

  const [htmlFeatureText, setHtmlFeatureText] = useState("");

  const [downloadAppTextTitle, setDownloadAppTextTitle] = useState("");
  const [downloadAppTextGoogle, setDownloadAppTextGoogle] = useState("");
  const [downloadAppTextApp, setDownloadAppTextApp] = useState("");
  const [downloadAppColor, setDownloadAppColor] = useState("");
  const [downloadAppSize, setDownloadAppSize] = useState("");

  const [videoConferenceBtnText, setVideoConferenceBtnText] = useState("");
  const [videoConferenceUrl, setVideoConferenceUrl] = useState("");
  const [videoConferenceSize, setVideoConferenceSize] = useState("");
  const [videoConferenceColor, setVideoConferenceColor] = useState("");
  const [videoConferenceType, setVideoConferenceType] = useState("");

  const changeDisclaimerSize = () => {
    if (disclaimerFeatureSize === 1 || disclaimerFeatureSize === "1") {
      return `${lang.features.DisclaimerSize.medium}`;
    }
    if (disclaimerFeatureSize === 2 || disclaimerFeatureSize === "2") {
      return `${lang.features.DisclaimerSize.large}`;
    }
    if (disclaimerFeatureSize === 0 || disclaimerFeatureSize === "0") {
      return `${lang.features.DisclaimerSize.small}`;
    }
  };

  const changeQuoteSize = () => {
    if (quoteFeatureSize === 1 || quoteFeatureSize === "1") {
      return `${lang.features.QuoteSize.medium}`;
    }
    if (quoteFeatureSize === 2 || quoteFeatureSize === "2") {
      return `${lang.features.QuoteSize.large}`;
    }
    if (quoteFeatureSize === 0 || quoteFeatureSize === "0") {
      return `${lang.features.QuoteSize.small}`;
    }
  };

  const changeDownloadAppSize = () => {
    if (downloadAppSize === 1 || downloadAppSize === "1") {
      return `${lang.features.QuoteSize.medium}`;
    }
    if (downloadAppSize === 2 || downloadAppSize === "2") {
      return `${lang.features.QuoteSize.large}`;
    }
    if (downloadAppSize === 0 || downloadAppSize === "0") {
      return `${lang.features.QuoteSize.small}`;
    }
  };

  const changeVideoConferenceBtnSize = () => {
    if (videoConferenceSize === 1 || videoConferenceSize === "1") {
      return `${lang.features.VideoConferenceButtonSize.medium}`;
    }
    if (videoConferenceSize === 2 || videoConferenceSize === "2") {
      return `${lang.features.VideoConferenceButtonSize.large}`;
    }
    if (videoConferenceSize === 0 || videoConferenceSize === "0") {
      return `${lang.features.VideoConferenceButtonSize.small}`;
    }
  };

  const bannerImage = () => {
    if (
      isBanner !== "false" &&
      ((bannerImageUrl === `${lang.staticBannerImage}` &&
        !userData.profileFormData[0].profileFormData) ||
        (bannerImageUrl !== `${lang.staticBannerImage}` &&
          bannerImageUrl !== ""))
    ) {
      return (
        <table>
          <tbody style={{ border: "none" }}>
            <tr style={{ border: "none" }}>
              <td style={{ border: "none" }}>
                <a
                  href={`//${bannerUrl}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={`${lang.imageUrl}/${bannerImageUrl}`}
                    alt="noImage"
                    style={{
                      marginTop: "10px",
                      maxWidth: "100%",
                      width: `${lang.features.bannerSize}`,
                      display: " block",
                    }}
                  />
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };

  const disclaimerText = () => {
    if (
      isDisclaimer !== "false" &&
      disclaimerFeatureText !== "" &&
      disclaimerFeatureText !== undefined
    ) {
      return (
        <table
          style={{
            paddingTop: "8px",
            width: "100%",
          }}
        >
          <tbody style={{ border: "none" }}>
            <tr style={{ border: "none" }}>
              <td style={{ border: "none" }}>
                <p
                  style={{
                    lineHeight: "120%",
                    paddingTop: "10px",
                    color: disclaimerFeatureColor,
                    fontSize: changeDisclaimerSize(),
                    wordBreak: "break-all",
                  }}
                >
                  {disclaimerFeatureText}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };

  const DownloadApp = () => {
    if (
      isDownloadApps !== "false" &&
      downloadAppTextTitle !== "" &&
      downloadAppTextTitle !== undefined
    ) {
      return (
        <table
          style={{
            paddingTop: "8px",
            width: "100%",
          }}
        >
          <tbody style={{ border: "none" }}>
            <tr style={{ border: "none" }}>
              <td style={{ border: "none" }}>
                <span
                  style={{
                    display: "block",
                    paddingTop: "10px",
                    color: downloadAppColor,
                    fontSize: changeDownloadAppSize(),
                  }}
                >
                  {downloadApp.downloadAppText[0].Title}
                </span>
                {downloadAppTextGoogle !== "" ? (
                  <a
                    href={`//${downloadAppTextGoogle}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={`${lang.tempIcons.GooglePlay}`}
                      alt="noImage"
                      style={{
                        maxWidth: "100%",
                        width: `100px`,
                        display: " inline",
                      }}
                    />
                  </a>
                ) : null}

                {downloadAppTextApp !== "" ? (
                  <a
                    href={`//${downloadAppTextApp}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={`${lang.tempIcons.AppStore}`}
                      alt="noImage"
                      style={{
                        maxWidth: "100%",
                        width: `100px`,
                        display: " inline",
                      }}
                    />
                  </a>
                ) : null}
              </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };

  const QuoteText = () => {
    if (
      isQuote !== "false" &&
      quote.quoteText[0].quoteText !== "" &&
      quote.quoteText[0].quoteText !== undefined
    ) {
      return (
        <table
          style={{
            maxWidth: "100%",
          }}
        >
          <tbody style={{ border: "none" }}>
            <tr style={{ border: "none" }}>
              <td style={{ border: "none" }}>
                <div
                  style={{
                    padding: "1px 8px 4px 2px",
                    color: quoteFeatureColor,
                    fontSize: changeQuoteSize(),
                    wordBreak: "break-all",
                  }}
                >
                  {quoteFeatureText}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };

  const htmlText = () => {
    if (isHtml !== "false" && htmlFeatureText !== "") {
      return (
        <div
          style={{ color: "black" }}
          dangerouslySetInnerHTML={{ __html: htmlFeatureText }}
        ></div>
      );
    }
  };

  const videoConferenceFuc = () => {
    if (isVideoConference !== "false" && videoConferenceBtnText !== "") {
      return (
        <a
          href={`//${videoConferenceUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          alt="React"
        >
          <button
            className="btn-sm"
            style={{
              background: videoConferenceColor,
              color: "#fff",
              borderRadius: "5px",
              border: "none",
              padding: changeVideoConferenceBtnSize(),
            }}
          >
            <img
              src={lang.features.VideoConferenceImages.Zoom}
              width={20}
              style={{ marginRight: "5px" }}
              alt="test"
            />
            {videoConference.videoConferenceText[0].videoConferenceText}
          </button>
        </a>
      );
    }
  };

  const isFeaturesUsed = () => {
    return (
      <table
        style={{
          maxWidth: "450px",
          width: "100%",
          paddingTop: "10px",
          border: "none",
        }}
      >
        <tbody style={{ border: "none" }}>
          <tr style={{ border: "none" }}>
            <td style={{ border: "none" }}>
              {bannerImage()}
              {QuoteText()}
              {disclaimerText()}
              {htmlText()}
              {DownloadApp()}
              {videoConferenceFuc()}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  useEffect(() => {
    setCurrentFeature(userFeatures.currentFeature[0].currentFeature);
    setBannerImageUrl(uploadBanner.bannerImage[0].bannerImageUrl);
    setBannerUrl(uploadBanner.bannerurl[0].bannerUrl);
    setDisclaimerFeatureText(disclaimer.disclaimerText[0].disclaimerText);
    setDisclaimerFeatureColor(disclaimer.disclaimerColor[0].disclaimerColor);
    setDisclaimerFeatureSize(disclaimer.disclaimerSize[0].disclaimerSize);
    setQuoteFeatureText(quote.quoteText[0].quoteText);
    setQuoteFeatureColor(quote.quoteColor[0].quoteColor);
    setQuoteFeatureSize(quote.quoteSize[0].quoteSize);
    setHtmlFeatureText(htmlFeature.HtmlFeature[0].Html);
    setDownloadAppTextTitle(downloadApp.downloadAppText[0].Title);
    setDownloadAppTextApp(downloadApp.downloadAppText[0].AppStore);
    setDownloadAppTextGoogle(downloadApp.downloadAppText[0].GooglePlay);
    setDownloadAppSize(downloadApp.downloadAppSize[0].downloadAppSize);
    setDownloadAppColor(downloadApp.downloadAppColor[0].downloadAppColor);
    setVideoConferenceBtnText(
      videoConference.videoConferenceText[0].videoConferenceText
    );
    setVideoConferenceUrl(
      videoConference.videoConferenceLink[0].videoConferenceLink
    );
    setVideoConferenceSize(
      videoConference.videoConferenceSize[0].videoConferenceSize
    );
    setVideoConferenceColor(
      videoConference.videoConferenceColor[0].videoConferenceColor
    );
    setVideoConferenceType(
      videoConference.videoConferenceType[0].videoConferenceType
    );
  }, [
    disclaimer,
    quote,
    htmlFeature,
    uploadBanner,
    downloadApp,
    videoConference,
    userFeatures,
    userStyle,

    currentFeature,
    bannerImageUrl,
    bannerUrl,
    uploadBanner,
    disclaimerFeatureText,
    disclaimerFeatureColor,
    disclaimerFeatureSize,
    quoteFeatureText,
    quoteFeatureColor,
    quoteFeatureSize,
    htmlFeatureText,
    downloadAppTextTitle,
    downloadAppTextGoogle,
    downloadAppTextApp,
    downloadAppColor,
    downloadAppSize,
    videoConferenceBtnText,
    videoConferenceColor,
    videoConferenceSize,
    videoConferenceUrl,
    videoConferenceType,
  ]);

  return <>{isFeaturesUsed()}</>;
};

export default FeaturesTemplate;
